import type { Ball } from './types';

export function integrateBall(ball: Ball, dt: number): void {
  if (ball.attached) return;
  ball.x += ball.vx * dt;
  ball.y += ball.vy * dt;
}

export function setBallSpeed(ball: Ball, speed: number): void {
  const cur = Math.hypot(ball.vx, ball.vy);
  if (cur < 0.001) {
    ball.vx = 0;
    ball.vy = -speed;
    return;
  }
  const s = speed / cur;
  ball.vx *= s;
  ball.vy *= s;
}

export function cloneBall(src: Ball, angle: number, speed: number): Ball {
  return {
    x: src.x,
    y: src.y,
    vx: Math.cos(angle) * speed,
    vy: Math.sin(angle) * speed,
    r: src.r,
    attached: false,
    fire: src.fire,
    piercing: src.piercing,
    trail: [],
  };
}
